import axios from 'axios';

const MESSAGE_CENTRAL_BASE_URL = 'https://cpaas.messagecentral.com';
const CUSTOMER_ID = 'C-0E0720CE9BB846E';
const ACCOUNT_PASSWORD = 'Fluxion@007';

const DASHBOARD_URL =
  process.env.REACT_APP_CLOUD_DASHBOARD_URL ||
  'https://flabs-test.fluxionsolution.com/api/7990/DashBoardAppLogin';

const TENANT_AUTH_URL =
  process.env.REACT_APP_TENANT_AUTH_URL ||
  'https://desk.fluxionsolution.com/api/TenantMaster/auth/mobile';

const TENANT_MASTER_API_KEY =
  process.env.REACT_APP_TENANT_MASTER_API_KEY ||
  'GaLtITOwSVwnldgZkqOEGHsJ9y2q7eSXXemzBpRK7dg3GQ66';

function base64Password() {
  return btoa(ACCOUNT_PASSWORD);
}

export async function cloudDashBoardLookup(mobileNo) {
  const headers = {
    'Content-Type': 'application/json',
    Accept: '*/*',
    MobileNo: mobileNo,
  };
  const bearer = process.env.REACT_APP_DASHBOARD_BEARER_TOKEN;
  if (bearer) {
    headers.Authorization = bearer.startsWith('Bearer ') ? bearer : `Bearer ${bearer}`;
  }
  const { data } = await axios.post(DASHBOARD_URL, null, { headers });
  return data;
}

export async function generateMessageCentralToken() {
  const { data } = await axios.get(
    `${MESSAGE_CENTRAL_BASE_URL}/auth/v1/authentication/token`,
    {
      params: {
        customerId: CUSTOMER_ID,
        key: base64Password(),
        scope: 'NEW',
        country: 91,
      },
    }
  );
  return data.token;
}

export async function sendOtpMessageCentral(mobileNo, authToken) {
  const { data } = await axios.post(
    `${MESSAGE_CENTRAL_BASE_URL}/verification/v3/send`,
    null,
    {
      params: {
        countryCode: '91',
        flowType: 'SMS',
        mobileNumber: mobileNo,
      },
      headers: {
        authToken,
      },
    }
  );
  return data;
}

export async function validateOtpMessageCentral(verificationId, code, authToken) {
  const { data } = await axios.get(
    `${MESSAGE_CENTRAL_BASE_URL}/verification/v3/validateOtp`,
    {
      params: {
        verificationId,
        code,
      },
      headers: {
        authToken,
      },
    }
  );
  return data;
}

export async function tenantMasterAuth(mobileNo) {
  const { data } = await axios.post(
    TENANT_AUTH_URL,
    {
      mobileNo,
      clientID: 0,
      tenantTotpCode: '',
    },
    {
      headers: {
        Accept: '*/*',
        'Content-Type': 'application/json',
        'X-API-Key': TENANT_MASTER_API_KEY,
      },
    }
  );
  return data;
}
